import { useState, useEffect } from 'react';
import { apiClient } from '../../api_actions';
import { orbitalSpinner } from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';
import { chartTheme } from '../../constants/chartTheme';

// Separate data transformation
const transformLocationData = (data) => {
    return data
        .map(item => ({
            type: item.type,
            value: Number(item.value)
        }))
        .sort((a, b) => b.value - a.value);
};

// Separate API call
const fetchEventsByLocationData = async (startAndEndUnixDatesParams = '') => {
    try {
        const res = await apiClient.post(`read/dashboardlocations?${startAndEndUnixDatesParams()}`);
        if (res.status && res.data) {
            return transformLocationData(res.data);
        }
        return [];
    } catch (error) {
        console.error('Failed to load data:', error);
        return [];
    }
};

// Factory function - simplified
const createEventsByLocationConfig = (data = [], formatDateRange = () => '') => ({
    theme: chartTheme,
    series: [
        {
            type: 'pie',
            angleKey: 'value',
            calloutLabelKey: 'type',
        },
    ],
    title: { text: 'Events by Location' },
    subtitle: { text: formatDateRange() },
    data: data,
    overlays: {
        loading: {
            renderer: orbitalSpinner,
        },
    },
});

export const EventsByLocationChartLogic = (startAndEndUnixDatesParams, formatDateRange) => {
    const [EventsByLocationConfig, setEventsByLocationConfig] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const data = await fetchEventsByLocationData(startAndEndUnixDatesParams);
            setEventsByLocationConfig(createEventsByLocationConfig(data, formatDateRange));
            setLoading(false);
        };

        loadData();
    }, [startAndEndUnixDatesParams, formatDateRange]);

    return {
        EventsByLocationConfig,
        loading,
    };
};
